export function initSmoothScroll({ gsap, ScrollTrigger, Lenis, reducedMotion }) {
    if (reducedMotion || document.documentElement.hasAttribute('data-disable-smooth-scroll')) {
        return null;
    }

    const lenis = new Lenis({
        anchors: true,
        autoRaf: false,
        smoothWheel: true,
        syncTouch: false,
        wheelMultiplier: 0.9,
        prevent: (node) => node.closest?.('[data-lenis-prevent]') !== null,
    });

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    window.addEventListener('load', () => {
        lenis.resize();
        ScrollTrigger.refresh();
    }, { once: true });

    return lenis;
}
